<template>
  <div class="addVistor">
    <div class="flex">
      <div class="left" :style="{ flex: 'auto', width: 'calc(100% - 330px)' }">
        <div style="height: calc(100vh - 130px); overflow: auto" class="pt-4">
          <add-visitor ref="childVisitor" @childData="getChildData" :type="`random`" @changeDialog="personDialog"></add-visitor>
          <div class="bottom mt-10 pl-6 pr-6">
            <div class="bottom_main text-medium-x mb-4 font-bold">2.设置任务</div>
            <add-task ref="childTask"></add-task>
          </div>
        </div>
        <div class="submit-btn p-4 pl-6 pr-6">
          <!-- <div class="footer-text">
            调查员预计到手金额<span class="price-style">{{ estimatedCost || '--' }}</span> 元(不包含阶梯计价)，若采用线上结算
            ，项目预计花费<span class="price-style">{{ actualCost || '--' }}</span> 元
            <el-tooltip
              effect="dark"
              :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
              placement="top"
            >
              <div class="icon-wrap">
                <span class="icon-font ico-tips">&#xe65b;</span>
              </div>
            </el-tooltip>
          </div> -->
          <div class="footer-text flex">
            <div class="flex  mr-10" v-show="actualCost>0">
              线上结算预估花费:
              <el-tooltip
                effect="dark"
                :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                placement="top"
              >
                <div class="icon-wrap">
                  <span class="icon-font ico-tips">&#xe65b;</span>
                </div>
              </el-tooltip>
              <span class="total ml4">{{actualCost}}</span>
            </div>
            <div class="flex" v-show="estimatedCost > 0">
              线下结算预估花费:
              <el-tooltip
                effect="dark"
                content="线下与调查员协商支付方式，纳税事宜，该金额为预估花费"
                placement="top"
              >
                <div class="icon-wrap">
                  <span class="icon-font ico-tips">&#xe65b;</span>
                </div>
              </el-tooltip>
              <span class="total ml4">{{estimatedCost}}</span>
            </div>

          </div>



          <div>
            <!-- <el-button @click="$emit('close')">取消</el-button> -->
            <el-button type="primary" :loading="loading" @click="onClickSubmit">确认</el-button>
          </div>
        </div>
      </div>
      <div class="right px-4 bg-card-bg-gray" :style="{ width: '290px', flex: 'none' }">
        <div :style="{ overflow: 'auto', height: 'calc(100vh - 75px)' }">
          <Advert></Advert>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" append-to-body width="30%" :before-close="handleDialogClose">
      <span>这尚未开通费用结算，无法设定线上结算，请前往开通</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="toOpen">去开通</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AddVisitor from '@/components/interview/add-visitor/add-visitor'
import AddTask from '@/components/interview/add-task/add-task'
import differenceWith from 'lodash.differencewith'
import isEqual from 'lodash.isequal'
import { newAddList, interviewerListByPhone, interviewerList } from '@/api/wenjuan/offline'
import GlobalConfig from '@/global/config'
import { log } from 'util'
import store from '@/store'
import Advert from '@/components/interview/advert/index.vue'

export default {
  components: {
    AddVisitor,
    AddTask,
    Advert
  },
  props: ['proxyType'],
  data() {
    return {
      dialogVisible: false,
      childVal: [], //子组件传来的值
      estimatedCost: 0, //预估费用
      actualCost: 0, // 实际金额
      loading: false
    }
  },
  computed: {
    inputAllInput() {
      if (this.inputValue == '') {
        return 0
      } else {
        let newArr = []
        let a = this.inputValue.split('\n')
        for (let key in a) {
          //过滤掉因为误点产生的空数组
          if (a[key] === '') {
            continue
          } else {
            newArr.push(a[key])
          }
        }
        return newArr.length
      }
    },
    selectLength() {
      return this.visitorList.length
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  methods: {
    handleDialogClose() {
      this.dialogVisible = false
    },
    toOpen() {
      this.dialogVisible = false
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    computedTotal(data){
      let total = 0
      data.forEach(item => {
        if (item.settleRule.unitPriceYuan && item.settleRule.expectedQuantity) {
          total += item.settleRule.unitPriceYuan * item.settleRule.expectedQuantity
        } else {
          total += 0
        }
      })
      return total;
    },
    getChildData(data, list) {
      console.log(data)
      this.childVal = data
      // settleMethod  0 线上  1 线下
      // 线上数据集合
      const onlineDataList = data.filter(it=> it.settleMethod === 0 && [1,2].includes(it.settleMode))
      //线下数据集合
      const offlineDataList = data.filter(it=> it.settleMethod === 1 && [1,2].includes(it.settleMode))

      const onlineTotal = this.computedTotal(onlineDataList);
      const offlineTotal = this.computedTotal(offlineDataList);

      // 线上计算结果
      const acc_rate = parseFloat(this.accRate)
      this.actualCost = isNaN(((1 + acc_rate) * onlineTotal).toFixed(2)) ? 0 : ((1 + acc_rate) * onlineTotal).toFixed(2)
      // 线下计算结果
      this.estimatedCost = isNaN(offlineTotal.toFixed(2)) ? 0 : offlineTotal.toFixed(2)
      // }
    },
    onClickSubmit() {
      // 判断是否选择了线上结算且未开通
      let flag = false
      this.childVal.forEach(it => {
        if (!it.settleMethod || it.settleMethod == 0) {
          flag = true
        }
      })
      if (store.getters.settlementType === 1 && flag) {
        this.dialogVisible = true
        return
      }
      let taskInfo = this.$refs.childTask.taskInfo
      let arr = [
        {
          vueComponent: taskInfo,
          validateArr: ['executionName', 'executionQuantity', 'executionSingleAmount', 'executionValidateTo']
        }
      ]
      this.$refs.childTask.$refs.taskInfo.validate(valid => {
        if (valid) {
          let validFlag = true
          this.childVal.forEach(it => {
            if (it.settleMode === 3 && it.settleMethod != 2) {
              it.settleRule.tiers.forEach((itTiers, indexTiers, arrTiers) => {
                itTiers.quantityLowerBound =
                  indexTiers > 0 ? arrTiers[indexTiers - 1].quantityUpperBound : itTiers.quantityLowerBound
                if (itTiers.quantityUpperBound === undefined || itTiers.unitPriceYuan === undefined) {
                  validFlag = false
                }
              })
              if (it.settleRule.expectedQuantity === undefined) {
                validFlag = false
              }
            } else if ((it.settleMode === 1 || it.settleMode === 2) && it.settleMethod != 2) {
              if (it.settleRule.expectedQuantity === undefined || it.settleRule.unitPriceYuan === undefined) {
                validFlag = false
              }
            }
          })

          if (!validFlag) {
            this.$message.error('请完善表单项')
            return
          }
          const list = this.childVal.map(item => {
            return {
              userId: item.id,
              userName: item.name ? item.name : '',
              phone: item.phone,
              justForCode: item.justForCode ? item.justForCode : false,
              settleMode: item.settleMode,
              settleRule: item.settleRule,
              settleMethod: item.settleMethod

              //添加虚拟参数后续删除
              // executionQuantity:1,
              // executionSingleAmount:1.00,
            }
          })
          const p = {
            surveyId: GlobalConfig.getSurveyId(),
            ...taskInfo,
            userList: list,
            entrustTaskId: this.$route.query.taskId || '',
            type: this.proxyType || ''
          }
          if (validFlag) {
            this.loading = true
            newAddList(p)
              .then(res => {
                if (res.data.code != 0) {
                  this.$message.error(res.data.msg)
                  this.loading = false;
                  return
                }
                this.$emit('close')
                this.loading = false
                // this.$router.push(
                //   "/questionnaire/publish/offline/random-interview?id=" +
                //     GlobalConfig.getSurveyId()
                // );
              })
              .catch(err => {
                this.$message.warning(err.message)
              })
          }
        } else {
          this.$message.error('请完善表单项')
          console.log('error submit!!')
          return false
        }
      })
    },
    // 监听子组件传递过来的事件
    personDialog(val) {
      console.log(val)
      this.$emit('emitDialog', val)
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.el-tag,
.el-tag--medium,
.el-tag--light {
  display: none;
}
.addVistor {
  .top {
    // margin-left: 80px;
    margin-top: 30px;
    .top_main {
      .top_main_header {
        display: flex;
        justify-content: space-between;
        .num,
        .task-title {
          color: #227ffe;
        }
      }
      .top_main_container {
        .inputGroup {
          display: flex;
          align-items: center;
          .el_input {
            width: 350px;
            margin-top: 20px;
            margin-right: 20px;
          }
        }
      }
    }
  }
  .bottom {
    ::v-deep .el-form-item__label {
      display: flex;
      justify-content: flex-end;
    }
    // margin-left: 80px;
    .task-info {
      border: 1px solid #f2f6fc;
      padding: 20px 30px;
      margin-bottom: 30px;

      ::v-deep .top {
        font-size: 16px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.7);
      }

      .el-form {
        width: 560px;
        margin: 0 auto;

        .el-form-item {
          margin-bottom: 22px;
        }
        .el-form-input {
          width: 400px;
        }
      }
    }
    .task-info {
      margin-bottom: 0;
    }
  }
  .inputGroup {
    display: flex;
    align-items: center;
    .el_input {
      width: 350px;
      margin-top: 20px;
      margin-right: 20px;
    }
  }
  .inputb {
    ::v-deep .el-textarea__inner {
      min-height: 500px !important;
    }
    .footTip {
      position: absolute;
      left: 400px;
      bottom: 90px;
    }
  }
  .submit-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: right;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    .footer-text {
      display: flex;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      span.total{
        font-size: 22px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #000;
        margin-left: 10px;
      }
      .flex{
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        line-height: 32px;
        &:first-child(2n){
          margin-left: 40px;
        }
      }
      .price-style {
        color: #000;
        font-weight: bold;
      }
      .parimy-btn {
        color: #ababab;
        margin-left: 5px;
      }
      .icon-wrap {
        margin-left: 10px;
        .ico-tips {
          color: rgba(0,0,0,0.35);
        }
      }
    }
    .el-button {
      min-width: 88px;
    }
  }
}
</style>
